"use client";

import Image from "next/image";

interface YouTubeThumbnailProps {
	videoId: string;
	alt: string;
	width?: number;
	height?: number;
	className?: string;
	sizes?: string;
	priority?: boolean;
}

export function YouTubeThumbnail({
	videoId,
	alt,
	width = 480,
	height = 270,
	className,
	sizes,
	priority = false,
}: YouTubeThumbnailProps) {
	return (
		<Image
			src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
			alt={alt}
			width={width}
			height={height}
			className={className}
			sizes={sizes}
			loading={priority ? undefined : "lazy"}
			priority={priority}
		/>
	);
}
